/* NKOSI - Ajout au panier en AJAX sans le tiroir du theme (G1, 2026-09-07)
   Contexte : settings.enable_cart_drawer = false (le tiroir Moon Bundles est le seul panier).
   Sans ce script, le formulaire produit fait un POST natif vers /cart et quitte la fiche produit.
   Ici : interception du clic sur .Sd_addProduct (fiche, barre sticky, grille, ajout rapide),
   POST /cart/add.js en fetch (intercepte par Moon Bundles pour ouvrir le tiroir ou le popup cadeau),
   mise a jour du compteur d'en-tete, affichage des erreurs dans .productErrors.
   Reversion : supprimer ce fichier et la balise <script> correspondante dans layout/theme.liquid. */
(function () {
  "use strict";
  if (window.__nkosiAtcAjax) return;
  window.__nkosiAtcAjax = true;
  if (window.cartDrawerEnable === true) return; /* le theme gere deja l'AJAX dans ce cas */
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var addUrl = window.cartAddUrl || (root + 'cart/add.js');
  /* Marché Collage, vague 2 des maquettes (P1, 28/09/2026) : l'ajout passe sans la fenêtre « Ajouté à votre panier » des
     cadeaux progressifs de Moon Bundles (moonbundle_ignore=true, qui fermait le tiroir) ; le tiroir complet s'ouvre
     ensuite (panier, frise, « Pour atteindre 39 € », total). Cadeaux resynchronisés par « cart:refresh », comme le
     tiroir du panier vide (nkosi-custom-scripts.js). */
  addUrl += (addUrl.indexOf('?') === -1 ? '?' : '&') + 'moonbundle_ignore=true';
  var cartUrl = window.cartUrl || (root + 'cart.js');

  function updateCount(cart) {
    var els = document.querySelectorAll('[data-cart-count]');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (cart.item_count > 0) { el.style.display = ''; el.textContent = cart.item_count < 100 ? String(cart.item_count) : ''; }
      else { el.style.display = 'none'; }
    }
  }
  function errBox(form) {
    var s = form.closest('.shopify-section') || form.parentElement;
    return s ? s.querySelector('.productErrors') : null;
  }
  function fallbackMsg() {
    var l = (window.Shopify && Shopify.locale) || 'fr';
    if (l === 'en') return 'Unable to add to cart, please try again.';
    if (l === 'de') return 'Artikel konnte nicht hinzugefügt werden, bitte erneut versuchen.';
    if (l === 'it') return 'Impossibile aggiungere al carrello, riprova.';
    return 'Impossible d’ajouter au panier, merci de réessayer.';
  }
  function showError(form, msg) {
    var b = errBox(form);
    if (b) { b.innerHTML = msg; b.style.display = ''; } else { window.alert(msg); }
  }
  /* vague 2 des maquettes (P1) : Moon Bundles redessine le tiroir en plusieurs temps, plus de 500 ms après le clic (0,16 de
     CLS mesuré sur mobile le 28/09) : comme le tiroir du panier vide, le corps et le pied quittent l'affichage le temps
     du redessin (classe nk-pv-transition sur <html>, une roue tourne, nkosi-marche-collage.css section 38) puis
     reviennent d'un coup à leur place finale. Fin : cadeaux resynchronisés (ou 1,2 s) et 280 ms de calme ; 2,2 s au plus. */
  var enTransition = false;
  function transitionTiroir() {
    var d = document.getElementById('moonbundle-cart-drawer'), racine = document.documentElement;
    if (!d || enTransition || !window.MutationObserver) return;
    enTransition = true;
    var debut = Date.now(), calme = null, cadeaux = false, obs = null, plafond = null;
    function fin() {
      if (!enTransition) return;
      enTransition = false;
      if (obs) obs.disconnect();
      clearTimeout(calme); clearTimeout(plafond);
      window.removeEventListener('moonbundle-cart-updated', surCadeaux);
      racine.classList.remove('nk-pv-transition');
    }
    function relancer() {
      clearTimeout(calme);
      calme = setTimeout(function () { if (cadeaux || Date.now() - debut > 1200) fin(); else relancer(); }, 280);
    }
    function surCadeaux(e) { if (e && e.detail && e.detail.caller === 'progressive-gifts') { cadeaux = true; relancer(); } }
    racine.classList.add('nk-pv-transition');
    window.addEventListener('moonbundle-cart-updated', surCadeaux);
    obs = new MutationObserver(relancer);
    obs.observe(d, { childList: true, subtree: true, characterData: true });
    plafond = setTimeout(fin, 2200);
    relancer();
  }
  window.nkTransitionTiroir = transitionTiroir; /* aussi pour le choix du cadeau (nkosi-mc-v2a.js) */
  window.nkOuvrirTiroir = function (cart) { updateCount(cart); ouvrirTiroir(cart); }; /* ajouts hors formulaire (nkosi-mc-v2b.js) */
  /* vague 2 des maquettes (P1) : le tiroir se redessine avec le panier reçu (écouteur de Moon Bundles sur window), les cadeaux
     se resynchronisent (paliers de 39 et 59 €), puis le tiroir s'ouvre ; sans Moon Bundles, seul le compteur change */
  function ouvrirTiroir(cart) {
    transitionTiroir();
    try {
      window.dispatchEvent(new CustomEvent('moonbundle-cart-updated', { detail: { cart: cart, caller: 'nkosi-atc' } }));
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    } catch (e) {}
    if (typeof window.openMoonBundleCartDrawer === 'function') { try { window.openMoonBundleCartDrawer(); } catch (e) {} }
  }
  function handle(form, btn) {
    if (btn && btn.classList.contains('is-loading')) return;
    if (btn) btn.classList.add('is-loading');
    var b = errBox(form);
    if (b) { b.style.display = 'none'; b.innerHTML = ''; }
    var fd = new FormData(form);
    fetch(addUrl, { method: 'POST', body: fd, headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) {
        return r.json().then(function (j) { return { ok: r.ok, json: j }; }, function () { return { ok: r.ok, json: null }; });
      })
      .then(function (res) {
        if (!res.ok) {
          showError(form, (res.json && (res.json.description || res.json.message)) || fallbackMsg());
          return;
        }
        var qa = form.closest('.quick-add-popup');
        if (qa) {
          qa.classList.remove('show');
          var qb = form.closest('[quick-add-body]');
          if (qb) qb.innerHTML = '';
          document.body.classList.remove('quick-add-popup-open');
        }
        var a = document.getElementById('addToCartAlert');
        if (a && a.play) { try { a.play(); } catch (e) {} }
        return fetch(cartUrl, { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            updateCount(cart);
            document.dispatchEvent(new CustomEvent('nkosi:cart:added', { detail: { cart: cart, item: res.json } }));
            ouvrirTiroir(cart);
          });
      })
      .catch(function () { showError(form, fallbackMsg()); })
      .then(function () {
        setTimeout(function () {
          if (btn) btn.classList.remove('is-loading');
          var s = document.querySelectorAll('.Sd_addProduct.is-loading');
          for (var i = 0; i < s.length; i++) s[i].classList.remove('is-loading');
        }, 600);
      });
  }
  function isAtcForm(f) {
    if (!f || f.tagName !== 'FORM') return false;
    var a = f.getAttribute('action') || '';
    return a.indexOf('/cart/add') !== -1 && !!f.querySelector('.Sd_addProduct');
  }
  document.addEventListener('click', function (evt) {
    var t = evt.target;
    if (!t || !t.closest) return;
    var btn = t.closest('.Sd_addProduct');
    if (!btn) return;
    var form = btn.closest('form');
    if (!isAtcForm(form)) return;
    evt.preventDefault();
    evt.stopImmediatePropagation();
    handle(form, btn);
  }, true);
  document.addEventListener('submit', function (evt) {
    var form = evt.target;
    if (!isAtcForm(form)) return;
    evt.preventDefault();
    evt.stopImmediatePropagation();
    handle(form, form.querySelector('.Sd_addProduct'));
  }, true);
})();
